import { useQuery } from 'react-query';
import { NarrativeRequest } from 'utilitys/narrative/narrativeTools';

import { getWidgetData as queryFn } from 'api/endPoints/getWidgetData';
import { QueryKeys } from 'api/queryKeys';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { SelectByOptionsValue } from 'components/widgets/RiskDensity/RiskDensity.utils';

export const useQueryRiskDensityBy = (params: QueryParams, endpoint: string) => {
    return useQuery<QueryFnResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['riskDensityBy', params],
        queryFn: () => {
            //eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { selectBy, ...rest } = params; //delete selectBy property
            return queryFn(rest, endpoint);
        },
        enabled: params.id.length > 0 && Boolean(params.selectBy),
    });
};

export interface QueryParams extends NarrativeRequest {
    id: number[];
    filter: {
        filters: IFilter[];
    };
    startDate: number | null;
    endDate: number | null;
    isWeekResolution: boolean;
    selectBy: SelectByOptionsValue;
}

export interface IHeatMapData {
    endDate: number;
    numOfDelayDrivers: number;
    numOfTasksPerMonth: number;
    percentile: number;
    score: number;
    startDate: number;
}

export interface QueryFnResponse {
    info?: IToolTip;
    startProjectDate: number;
    endProjectDate: number;
    heatMapItemResponseList: IHeatMapData[];
}

export type QueryResponse = QueryFnResponse;
